import * as React from "react";
import FormControlLabel from "@mui/material/FormControlLabel/FormControlLabel";
import {Box} from "@mui/system";
import Checkbox from "@mui/material/Checkbox/Checkbox";
import moduleStyles from "./Styles.module.css";

export default function LegalCheckboxLabel({handleCheckbox}) {

    return(
        <Box sx={styles.container}>
            <FormControlLabel control={<Checkbox onChange={handleCheckbox} sx={{ '& .MuiSvgIcon-root': { fontSize: '20px', color: '#0f0a06', mb: '2px' } }} />}
                  label={
                      <Box sx={styles.font} fontSize={{xs: '12px', sm: '12px', md: '14px', lg: '14px'}}>
                          I agree to Remarkable AI’s <a href="https://www.beremarkable.ai/legal/terms" className={moduleStyles.link} rel="noopener" target="_blank">
                          Terms and Conditions
                      </a> and <a href="https://www.beremarkable.ai/legal/privacy-policy" className={moduleStyles.link} rel="noopener" target="_blank">
                          Privacy Policy.
                      </a>
                      </Box>
                  }
            />
        </Box>

    )
}

const styles = {
    container: {
        px: '20px',
        py: '10px'
    },
    checkCircle: {
        fontSize: '20px',
        color: '#0f0a06',
        mr: '10px'
    },
    link: {
        color: '#0f0a06',
        textDecoration: 'underline'
    },
    font: {
        fontFamily: 'FustatRegular'
    }
}